import * as React from "react";
import * as url from "url";
import cx from "classnames";
import { IconWrapper } from "common/icons";
import PACKS from "common/icons/packs";
import Spinner from "common/components/spinner";
import ImageHolder from "common/components/imageHolder";
// styles

const styles = require("./embeddedVideo.scss");

interface IProps extends React.HTMLProps<HTMLDivElement> {
  width: number;
  height: number;
  embeddedVideo: Vingle.CardContent.EmbeddedVideoData;
  posterOnly?: boolean;
}

class EmbeddedVideo extends React.PureComponent<
  IProps,
  { isLoading: boolean }
> {
  public state = {
    isLoading: true,
  };

  public render() {
    const {
      width,
      height,
      posterOnly,
      embeddedVideo,
      style,
      className,
      ...rest
    } = this.props;
    const host = url.parse(embeddedVideo.embedUrl).hostname;
    const wrapperStyle = {
      width: `${width}px`,
      ...style,
    };

    return (
      <div
        className={cx(styles.wrapper, className)}
        style={wrapperStyle}
        {...rest}
      >
        <div>
          {this.state.isLoading ? <Spinner className={styles.loader} /> : null}
          {posterOnly ? (
            <div className={styles.postWrapper}>
              <ImageHolder
                fit="cover"
                width={width}
                height={height}
                src={embeddedVideo.poster}
                previewColor={embeddedVideo.previewColor}
                blurHash={embeddedVideo.blurHash}
                onLoad={this.handleLoadDone}
              />
              <div className={styles.iconWrapper}>
                <IconWrapper
                  icon={PACKS.MEDIA_BOX.PLAY}
                  className={styles.playIcon}
                />
              </div>
            </div>
          ) : (
            <iframe
              itemProp="image"
              width={width}
              height={height}
              src={embeddedVideo.embedUrl.replace(/(https:|http:)/, "")}
              style={{ maxWidth: "100%" }}
              onLoad={this.handleLoadDone}
              allowFullScreen={true}
            />
          )}
        </div>

        <a target="_blank" href={embeddedVideo.src}>
          <div className={styles.footnote}>
            {`${host}`}
            <IconWrapper
              className={styles.linkArrowIcon}
              icon={PACKS.POST_SHOW.LINK_PREVIEW_ARROW}
            />
          </div>
        </a>
      </div>
    );
  }

  private readonly handleLoadDone = () => {
    this.setState({
      isLoading: false,
    });
  };
}

export default EmbeddedVideo;
